import { Constantes } from "../constants/constantsGlobal"; 
import { RequestChatBotProjectSecret } from "../models/interfaceChatBotProjectSecret";
import { iResponse } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";
  
  export const chatbotProjectSecret = async (request: RequestChatBotProjectSecret, user: any, setUser: (user: any) => void): Promise<iResponse>=> {
    try {
      const response = await setupInterceptor(Constantes.URI_ChatBotProjectSecret, user, setUser, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });
      
      if (response.status == 400) {
        const data = await response.json(); 
        return data; 
      } 
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      //console.error('Error al obtener datos:', error);
      throw error;
    } 
    

  }